module.exports = __webpack_public_path__ + "static/media/page6.e01b211e.png";